export default __webpack_public_path__ + "a69ba34.png";